import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiProvider } from '../../providers/api/api';
import { AuthService } from '../../providers/auth/auth.service';

@Component({
  selector: 'app-mercadopago-return',
  templateUrl: './mercadopago-return.component.html',
  styleUrls: ['./mercadopago-return.component.scss']
})
export class MercadoPagoReturnComponent implements OnInit, OnDestroy {
  message = 'Aguardando confirmação da assinatura...';
  error: string | null = null;
  redirectIn = 6;
  redirectPath = '/professor/perfil';
  externalReference: string | null = null;
  preapprovalId: string | null = null;
  status: string | null = null;

  private timer: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiProvider,
    private auth: AuthService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe(async (params) => {
      this.externalReference = params.get('external_reference');
      this.preapprovalId = params.get('preapproval_id') || params.get('id');
      this.status = params.get('status');

      this.setRedirectPath();

      try {
        const query: any = {};
        if (this.externalReference) query.external_reference = this.externalReference;
        if (this.preapprovalId) query.preapproval_id = this.preapprovalId;
        if (this.status) query.status = this.status;

        await this.api.get('mercadopago/return', { params: query });
      } catch (err) {
        this.error = 'Não foi possível confirmar a assinatura agora.';
        this.toastr.error(this.error, '', { timeOut: 4000 });
      }

      this.startCountdown();
    });
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  private setRedirectPath() {
    const user = this.auth.retrieveLocalUser();
    if (!user) {
      this.redirectPath = '/login';
      return;
    }

    if (user.account_type === 'nutri') {
      this.redirectPath = '/nutri/perfil';
      return;
    }

    if (user.account_type === 'teacher') {
      this.redirectPath = '/professor/perfil';
      return;
    }

    this.redirectPath = '/dashboard';
  }

  private startCountdown() {
    this.timer = setInterval(() => {
      this.redirectIn -= 1;
      if (this.redirectIn <= 0) {
        clearInterval(this.timer);
        this.router.navigate([this.redirectPath]);
      }
    }, 1000);
  }
}
